import { Asterisk } from "lucide-react";

const ITEMS = [
  "Zero rental fees",
  "24/7 telemetry restocking",
  "Guaranteed infrared drop",
  "Micro markets",
  "Bean-to-cup coffee",
  "Smart touchless coolers",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-7 font-display text-lg font-bold uppercase tracking-wide text-[#FBF7EF] sm:text-xl">
          {item}
        </span>
        <Asterisk className="h-6 w-6 shrink-0 text-[#C9A227]" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="brand-marquee-strip"
      className="marquee-mask relative -rotate-[0.6deg] scale-[1.01] overflow-hidden border-y-2 border-[#16120E] bg-[#1B365D] py-4"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
